
export enum PlanoStatsNiveau {
    DIVISION = 'division',
    SECTION = 'section',
    TYPE_PRODUIT_WEB = 'typeproduitweb',
    PRODUIT = 'produit',
    PROD_ONLY = "prodonly",
}

export function getNiveauIndex(niveau: PlanoStatsNiveau): number {
    switch (niveau) {
        case PlanoStatsNiveau.DIVISION:
            return 0;
        case PlanoStatsNiveau.SECTION:
            return 1;
        case PlanoStatsNiveau.TYPE_PRODUIT_WEB:
            return 2;
        case PlanoStatsNiveau.PRODUIT:
            return 3;
        case PlanoStatsNiveau.PROD_ONLY:
            return 4;
        default:
            return 0;
    }
}

export function getNiveauFromIndex(index: number): PlanoStatsNiveau {
    switch (index) {
        case 0:
            return PlanoStatsNiveau.DIVISION;
        case 1:
            return PlanoStatsNiveau.SECTION;
        case 2:
            return PlanoStatsNiveau.TYPE_PRODUIT_WEB;
        case 3:
            return PlanoStatsNiveau.PRODUIT;
        case 4:
            return PlanoStatsNiveau.PROD_ONLY;
        default:
            return PlanoStatsNiveau.DIVISION;
    }
}


export enum PlanoStatsMode {
    MAG_PROD = 'magProd',
    PROD = 'prod'
}

export interface PlanoStatsParams {
    niveau: PlanoStatsNiveau;
    mag: string;
    div: string;
    section?: string;
    tpw?: string;
    mode?: PlanoStatsMode;
    produit?: string;
    ens?: boolean;
}

export interface PlanoStatsItem {
    txt: string;
    order: string;
    ventes_jr: number;
    cle: string;
    nbr_jr_demo: number;
    nbr_result: number;
    prix: number;
    couleur: string;
}

export interface TypeProduitWeb {
    tpw_cd: string;
    tpw_descr: string;
    tpw_descr_aff: string;
}